import React from "react"
import PropTypes from "prop-types"
import Danger from "./Danger"
import { languageSet } from "@qubit-utill/src";

const EditType = ({ className, onClick }) => {
  return <Danger title={languageSet("수정")} className={className} onClick={onClick} />
}

EditType.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default EditType
